import { styled } from '@linaria/react';
import { fonts, bodyFont, colors, space } from '../../theme/tokens';

export const EmptyMessage = styled.p`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  color: ${colors.fontSecondary};
  text-align: center;
  padding: ${space[8]} 0;
`;
